// extracted by mini-css-extract-plugin
export default {"header":"LogoHeader_header__s9uji","fffLogo":"LogoHeader_fffLogo__Nng3d"};